import _ from 'lodash';
import { translate } from '../../../../scripts/core/tools/translate';
const layers = () => require('../../../../scripts/layers').default;
import api from '../../../../scripts/api';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class GreenfieldFilterFactory {
    constructor ({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData () {
        const features = layers().get('Greenfield', this.currentMap).getFeatures();
        const data = [];

        data.push({
            name: 'type',
            position: 2,
            visible: isAuthorized(FeaturePermission.LAYER_GREENFIELD.filterType),
            fields: [{
                title: translate('Common.Type'),
                name: 'IdType',
                dataSource: _(features)
                    .map(x => x.properties.Type)
                    .flatten()
                    .uniqBy(x => x.Id)
                    .map(t => ({
                        text: t.Name,
                        value: t.Id
                    })).value(),
                value: 'value',
                text: 'text',
                skipAll: true,
                type: 'multiselect'
            }]
        });

        return data.filter(c => c.visible);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/greenfield.factory.js